import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Block } from "./library/container";
import { Link } from "./library/link";
export const ButtonBlock = (p)=>/*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "cta",
            children: /*#__PURE__*/ _jsx(Link, {
                url: p.href,
                className: `button`,
                children: p.caption
            })
        })
    });
